var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.reducedProductApplications),function(application){return _c('span',{key:application,class:_vm.applicationClass(application)},[_vm._v("\n            "+_vm._s(application)+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }